import React, { useState } from 'react';
import PhotoLightbox from './PhotoLightbox';

interface Props {
  url: string;
  alt?: string;
  /** Filename hint for the download in the lightbox (no extension). */
  downloadName?: string;
  /** Extra classes for the thumbnail img (size/shape differ by surface). */
  className?: string;
}

/**
 * A photo thumbnail that lifts slightly on hover (an affordance that it's
 * tappable) and opens a full-screen PhotoLightbox on click. Used by the parent
 * Recent feed and the Moments album so every shared photo can be viewed large
 * and downloaded. Deliberately just view + download — no reactions/comments.
 */
const ClickablePhoto: React.FC<Props> = ({ url, alt, downloadName, className }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        data-testid="clickable-photo"
        onClick={() => setOpen(true)}
        aria-label="View photo full screen"
        className="group overflow-hidden rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        <img
          src={url}
          alt={alt || 'Photo'}
          loading="lazy"
          className={`cursor-zoom-in bg-gray-100 object-cover transition-transform duration-200 ease-out group-hover:scale-105 ${
            className || 'h-20 w-20'
          }`}
        />
      </button>
      {open && (
        <PhotoLightbox
          url={url}
          alt={alt}
          downloadName={downloadName}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default ClickablePhoto;
